import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_reorder = _resolveComponent("ion-reorder")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_reorder_group = _resolveComponent("ion-reorder-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmSelect(true)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { style: {"padding-right":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => [
                    (_ctx.isSecSchoolStudents)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Target 1-2 professions"))
                      : (_openBlock(), _createElementBlock("p", _hoisted_2, "Target 1-2 professions & 2-3 employer segments for each"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_reorder_group, {
          onIonItemReorder: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doReorder($event, _ctx.selectedProfessions))),
          disabled: false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProfessions, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                value: item.id
              }, [
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_reorder, {
                      slot: "start",
                      style: {"margin-inline-end":"8px"}
                    }),
                    _createVNode(_component_ion_label, {
                      class: "ion-text-wrap",
                      onClick: ($event: any) => (_ctx.openProfessionModal(item.id))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, [
                          _createElementVNode("b", null, _toDisplayString(idx+1) + ". " + _toDisplayString(item.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_ion_buttons, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _withModifiers(($event: any) => (_ctx.onDeleteChosenProfession(idx, item)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              size: "small",
                              slot: "icon-only",
                              icon: _ctx.trashOutline
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _withDirectives(_createVNode(_component_ion_list, { style: {"padding":"0 0 0 40px","border-bottom":"1px solid var(--ion-color-dark)"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "none",
                      button: "",
                      onClick: ($event: any) => (_ctx.openUniSegmentDeckModal(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createElementVNode("p", null, "working in", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_ion_buttons, {
                          slot: "end",
                          style: {"height":"24px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  size: "small",
                                  slot: "icon-only",
                                  icon: _ctx.refresh
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_ion_reorder_group, {
                      onIonItemReorder: ($event: any) => (_ctx.doReorder($event, item.selectedSegments)),
                      disabled: false
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.selectedSegments, (s, idx) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            key: s.id,
                            button: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_reorder, { slot: "start" }),
                              _createVNode(_component_ion_label, {
                                class: "ion-text-wrap",
                                onClick: _withModifiers(($event: any) => (_ctx.openSegmentModal(s)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", null, [
                                    _createElementVNode("b", null, _toDisplayString(s.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_ion_buttons, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _withModifiers(($event: any) => (_ctx.onDeleteChosenSegment(item, idx, s)), ["stop"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        size: "small",
                                        slot: "icon-only",
                                        icon: _ctx.trashOutline
                                      }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["onIonItemReorder"])
                  ]),
                  _: 2
                }, 1536), [
                  [_vShow, !_ctx.isSecSchoolStudents && idx <= 1]
                ])
              ], 8, _hoisted_3))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, { class: "ion-margin-top ion-justify-content-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              color: "primary",
              class: "add-item-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openUniProfessionDeckModal()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  slot: "start",
                  icon: _ctx.add
                }, null, 8, ["icon"]),
                _cache[4] || (_cache[4] = _createTextVNode(" Professions "))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}